import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { toast } from 'sonner';

// Notices other auth steps send back to the login through `?notice=`.
export function useLoginNotice() {
  const tMfa = useTranslations('auth.mfa');
  const tLogin = useTranslations('auth.login');
  const searchParams = useSearchParams();

  useEffect(() => {
    const notice = searchParams.get('notice');
    if (notice === 'mfa_expired') {
      toast.error(tMfa('expired'));
    } else if (notice === 'account_deleted') {
      // The confirmation of a deletion is read, not glanced at, so it stays until dismissed.
      toast.success(tLogin('notices.accountDeleted'), { duration: Infinity, closeButton: true });
    }
  }, [searchParams, tMfa, tLogin]);
}
